import { Provider } from 'mobx-react';
import * as React from 'react';
import { ContentMapExtension } from './ContentMapExtension';
import { ContentMapExtensionStore } from './store/ContentMapExtensionStore';
import { IInstance } from '../../interfaces/IInstance';
import { IFontSlots } from '../../interfaces/IFontSlots';

export interface IContentMapExtensionProps {
  tenant: string;
  environment: "Development" | "Test" | "Production";
  token: string;
  instance: IInstance;
  highlightColor: string;
  isMobile: boolean;
  fontSlots?: IFontSlots;
  styles?: React.CSSProperties;
}

export class IAContentMapExtension extends React.Component<IContentMapExtensionProps> {

  private contentMapExtensionStore: ContentMapExtensionStore;

  constructor(props: IContentMapExtensionProps) {
    super(props);
    this.contentMapExtensionStore = new ContentMapExtensionStore();
    this.updateProperties(props);
  }

  private updateProperties(props: IContentMapExtensionProps): void {
    this.contentMapExtensionStore.environment = props.environment;
    this.contentMapExtensionStore.tenant = props.tenant;
    this.contentMapExtensionStore.environment = props.environment;
    this.contentMapExtensionStore.token = props.token;
    this.contentMapExtensionStore.instance = props.instance;
    this.contentMapExtensionStore.highlightColor = props.highlightColor;
    this.contentMapExtensionStore.isMobile = props.isMobile;
    this.contentMapExtensionStore.styles = props.styles;
    this.contentMapExtensionStore.fontSlots = props.fontSlots;
  }

  public render(): JSX.Element {
    return (
      <Provider contentMapExtensionStore={this.contentMapExtensionStore}>
        <ContentMapExtension/>
      </Provider>
    )
  }
}
